import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "revico-widget" }
const _hoisted_2 = { class: "revico-community-talk-wrapper" }
const _hoisted_3 = { class: "revico-community-talk" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["ApiGetLoadMaster"], { status: $setup.layoutTagGetStatus }, {
      contents: _withCtx(() => [
        _createVNode($setup["HeaderPart"], {
          html: $setup.customHtmlCss?.headerPart
        }, null, 8 /* PROPS */, ["html"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("article", _hoisted_3, [
            _createVNode($setup["ReviCoLogo"]),
            _createCommentVNode(" 表示タグ内容をトリガーに表示 "),
            _createVNode($setup["ApiGetLoadWithAddMaster"], { status: $setup.talkRoomGetStatus }, {
              contents: _withCtx(() => [
                _createCommentVNode(" トークルームが1件でもあるとき "),
                ($setup.isExistTalkRooms())
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode($setup["CommunityTalkTitle"], {
                        title: $setup.wordSettings?.title
                      }, null, 8 /* PROPS */, ["title"]),
                      _createVNode($setup["TalkRoomCount"], {
                        talkRoomCount: $setup.talkRoomViewModel?.talkRoomCount,
                        talkRoomCountWithReply: $setup.talkRoomViewModel?.talkRoomCountWithReply,
                        wordSettings: $setup.wordSettings
                      }, null, 8 /* PROPS */, ["talkRoomCount", "talkRoomCountWithReply", "wordSettings"]),
                      _createVNode($setup["TalkRoomList"], {
                        talkRooms: $setup.talkRoomViewModel?.talkRooms,
                        wordSettings: $setup.wordSettings,
                        communityTalkStoreKey: $props.communityTalkStoreKey
                      }, null, 8 /* PROPS */, ["talkRooms", "wordSettings", "communityTalkStoreKey"]),
                      _createVNode($setup["TalkRoomMoreButton"], {
                        communityTalkStoreKey: $props.communityTalkStoreKey,
                        "more-button-display-name": $setup.wordSettings?.moreButtonDisplayName,
                        talkRoomCurrentDisplayCount: $setup.talkRoomViewModel?.talkRooms.length,
                        talkRoomCount: $setup.talkRoomViewModel?.talkRoomCount,
                        isProcessingAddTalkRoom: $setup.talkRoomGetStatus === $setup.ApiGetLoadAddStatus.addLoading,
                        onClickMoreButton: $setup.addTalkRoom
                      }, null, 8 /* PROPS */, ["communityTalkStoreKey", "more-button-display-name", "talkRoomCurrentDisplayCount", "talkRoomCount", "isProcessingAddTalkRoom"]),
                      _createVNode($setup["TalkRoomPost"], {
                        communityTalkStoreKey: $props.communityTalkStoreKey,
                        wordSettings: $setup.wordSettings
                      }, null, 8 /* PROPS */, ["communityTalkStoreKey", "wordSettings"])
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createCommentVNode(" トークルームが1件もない時 "),
                      _createVNode($setup["CommunityTalkTitle"], {
                        title: $setup.wordSettings?.title
                      }, null, 8 /* PROPS */, ["title"]),
                      _createVNode($setup["NoTalkRoom"], {
                        talkRoomNotFoundText: $setup.wordSettings?.talkRoomNotFoundText
                      }, null, 8 /* PROPS */, ["talkRoomNotFoundText"]),
                      _createVNode($setup["TalkRoomPost"], {
                        communityTalkStoreKey: $props.communityTalkStoreKey,
                        wordSettings: $setup.wordSettings
                      }, null, 8 /* PROPS */, ["communityTalkStoreKey", "wordSettings"])
                    ], 64 /* STABLE_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["status"])
          ])
        ]),
        _createVNode($setup["FooterPart"], {
          html: $setup.customHtmlCss?.footerPart
        }, null, 8 /* PROPS */, ["html"])
      ]),
      error: _withCtx(() => []),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["status"])
  ]))
}